module.exports = __webpack_public_path__ + "jurvansanomat_logo_valk-653534e35b6697a03a67.png";